import styled from 'styled-components'

export const Subheader = styled.h6`
  color: var(--primary);
  font-family: Sentinel;
`
